import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import {
    Paper,
    FormControl,
    TextField,
    Select,
    MenuItem,
    Typography,
    FormGroup,
} from '@material-ui/core';
import axios from 'axios';
import Common from '../../Common';
import SearchButton from '../questionnaireUser/QuestionnaireUserSearchButton';
import ResetButton from '../questionnaireUser/QuestionnaireUserResetButton';

const styles = (theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '95%',
        marginTop: '5px',
        justifyContent: 'center',
        minWidth: 1100,
    },
    grid: {
        // border: `1px solid ${theme.palette.divider}`,
        margin: '0px auto',
        marginTop: '10px',
        border: '1px solid rgba(0, 0, 0, 0.5);',
        borderRadius: '5px',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
    },
    formControll: {
        margin: '0px 7px',
    },
    dateSelect: {
        margin: '0px 7px 0px 55px',
    },
    controllLabel: {
        margin: '10px 0px 10px 20px',
    },
    fieldHover: {
        width: '375px',
        cursor: 'pointer',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
        },
    },
    conditionLeft: {
        width: '300px',
    },
    dataSelect:{
        width: '150px',
    },
    questionnaireList: {
        width: '600px',
    },
    conditionRight: {
        width: '350px',
    },
    select: {
        margin: theme.spacing(1),
        width: '300px',
    },
    title:{
        marginTop: '30px'
    },
    johokubunList:{
        borderBottom: 'solid 1px #E0E0E0',
    },
    inputKeyword:{
        margin: '20px 0px 10px 30px',
    },
    selectKubunArea: {
        marginLeft: '50px',
        alignItems: 'center',
    },
    questionnaireArea: {
        marginTop: '30px',
        marginLeft: '-25px',
        alignItems: 'center',
    },
    categorySelect:{
        margin: '15px 7px 0px 22px',
    },
    shubetsuSelect:{
        margin: '0px 7px 0px 22px',
    },
    memo:{
        margin: '0px 7px 0px 55px',
    },
    endFlg:{
        width:'100px'
    },
    deletionFlgList:{
        borderBottom: 'solid 2px #FFF',
        height:'40px',
    },
    to: {
        left: '20px',
        position: 'relative',
    },
    keyword:{
        margin: '0px 7px 0px 22px',
    },
    selectQuestionnaireLabel:{
        fontSize: '20px',
        margin: '20px 0px 10px 30px',
    }
});

const SettingUserSearch = withCookies((props) => {
    const { classes, setData, cookies, setAllUpdate, setIsLoading } = props;
    const [recordId, setRecordId] = React.useState('');
    const [creationStartDate, setCreationStartDate] = React.useState('');
    const [creationEndDate, setCreationEndDate] = React.useState('');
    const [questionnaireList, setQuestionnaireList] = React.useState([]);
    const [selectedQuestionnaireId, setSelectedQuestionnaireId] = React.useState('');
    const [displayQuestionnaireName, setDisplayQuestionnaireName] = React.useState('---選択してください---');
    const [keyword, setKeyword] = React.useState('');

    //-----------------------------------------------------------------
    //              ページに格納するデータの取得
    //-----------------------------------------------------------------
    function getQuestionnaireData() {
        if(questionnaireList.length === 0){
            //TOKEN取得
            axios
                .post(`${Common.apiServerUrl()}/api/auth/token`, {
                    headers: {
                        Authorization: 'Bearer ' + cookies.get('id_token'),
                    },
                    data: {},
                })
                .then(Common.handleErrors)
                .then((Response) => {
                    if (Response.success) {
                        cookies.set('token', Response.token, {
                            maxAge: 60 * 60 * 24 * 30, //30日間
                            httpOnly: false,
                            path: '/',
                            secure: true,
                        });

                        const jichitaiToken = cookies.get('x-jichitai-token');
                        const jichitaiId = cookies.get('x-jichitai-jichitaiid');

                        const header = {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'x-suppportcenter-token': Response.token,
                            'x-jichitai-jichitaiid': jichitaiId,
                            'x-jichitai-token': jichitaiToken,
                        };

                        //-------------------------------------------
                        //プルダウンに表示する情報区分の取得 APIアクセス先(johoKubun.js)
                        //cookieに保存している職員番号でGetアクセスを行う
                        //-------------------------------------------
                        // -------------------------axios------------------------------
                        axios
                            .get(`${Common.apiServerUrl()}/api/questionnaire`, {
                                headers: header,
                                data: {},
                            })
                            .then(Common.handleErrors)
                            .then((response) => {
                                const res = response.result;
                                if (response.success) {
                                    if (res.length === 0) {
                                        return;
                                    } else {
                                        setQuestionnaireList(res);
                                    }
                                } else {
                                    window.alert(`code : [${response.type}]\nmessage : ${response.message}`);
                                }
                            })
                            .catch((err) => {
                                console.error('QuestionnaireUserSearch.js :get err:' + err.message);
                            });
                    }
                })
                .catch((err) => {
                    console.error('QuestionnaireUserSearch.js :get err:' + err.message);
                });
        }
    }

    function handleQuestionnaireChange(questionnaireId){
        if(questionnaireId !== '' ){
            setSelectedQuestionnaireId(questionnaireId);
            setAllUpdate(false);
            setIsLoading(true);
            const selectQuestionnaire = questionnaireList.filter((d) => d.questionnaireId === questionnaireId);
            setDisplayQuestionnaireName(selectQuestionnaire[0].name);
            //検索条件のリセット
            setRecordId('');
            setCreationStartDate('');
            setCreationEndDate('');
            setKeyword('');
            //検索条件なしで検索
            axios.post(
                `${Common.apiServerUrl()}/api/questionnaire/user`,
                {
                    recordId: '',
                    creationStartDate: '',
                    creationEndDate: '',
                    questionnaireId,
                    keyword : ''
                },
                {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + cookies.get('access_token'),
                        'x-suppportcenter-token': cookies.get('token'),
                        'x-jichitai-jichitaiid': cookies.get('x-jichitai-jichitaiid'),
                        'x-jichitai-token': cookies.get('x-jichitai-token'),
                    },
                    data: {},
                }
            )
            .then(Common.handleErrors)
            .then((res) => {
                if (res.success) {
                    if(res.result.length === 0) window.alert('絞り込み条件に合致する結果が⾒つかりませんでした。');
                    setData(res.result);
                } else {
                    window.alert(`code : [${res.type}]\nmessage : ${res.message}`);
                }
            })
            .catch((err) => {
                console.error('QuestionnaireUserSearch.js handleQuestionnaireChange:get err:' + err.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
        }
        else{
            setSelectedQuestionnaireId('');
            setDisplayQuestionnaireName('---選択してください---');
            setData([]);
        }
    }

    function handleCreationDataStartChange(date){
        const dateArray = date.split('-');
        if(dateArray[0].length >= 5) {
            dateArray[0] = '9999';
            date = dateArray.join('-');
        }
        setCreationStartDate(date);
    }

    function handleCreationDataEndChange(date){
        const dateArray = date.split('-');
        if(dateArray[0].length >= 5) {
            dateArray[0] = '9999';
            date = dateArray.join('-');
        }
        setCreationEndDate(date);
    }


    useEffect(() => {
        if(questionnaireList.length === 0) getQuestionnaireData();
    },[]);

    return (
        <React.Fragment>
            <FormGroup className={classes.questionnaireArea} row>
                <Typography variant="body1" className={classes.selectQuestionnaireLabel}>
                    アンケート名：
                </Typography>
                    <React.Fragment>
                    <FormControl className={classes.categorySelect}>
                        {/* */}
                        <Select
                            id="multiple-checkbox-johoKubun"
                            value={displayQuestionnaireName}
                            className={classes.questionnaireList}
                            variant="outlined"
                        >
                            <MenuItem key={0} value={'---選択してください---'} className={classes.deletionFlgList} onClick={() => handleQuestionnaireChange('')}>{'---選択してください---'}</MenuItem>
                            {questionnaireList.map((rec, i) => (
                                <MenuItem key={i+1} value={rec.name} onClick={() => handleQuestionnaireChange(rec.questionnaireId)} className={classes.deletionFlgList}>
                                    {`${rec.name}`}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </React.Fragment>
            </FormGroup>
            <Typography className={classes.title} variant="h6" component="p">
                絞り込み条件設定
            </Typography>
            <Paper elevation={2} variant="outlined" className={classes.paper}>
                <div>
                    <FormGroup className={classes.selectKubunArea} row>
                        <Typography variant="body1" className={classes.inputKeyword}>
                                レコード番号：
                        </Typography>
                        <FormControl className={classes.formControll}>
                            <TextField
                                id="outlined-basic"
                                variant="outlined"
                                className={classes.conditionLeft}
                                margin="normal"
                                value={recordId}
                                onChange={(event) => setRecordId(event.target.value)}
                            />
                        </FormControl>
                        <Typography variant="body1" className={classes.inputKeyword}>
                                作成日：
                        </Typography>
                        <FormControl className={classes.dateSelect}>
                            <TextField
                                id="outlined-basic"
                                type="date"
                                variant="outlined"
                                className={classes.dataSelect}
                                margin="normal"
                                value={creationStartDate}
                                onChange={(event) => handleCreationDataStartChange(event.target.value)}
                            />
                        </FormControl>
                        <Typography className={classes.to} variant="h6" component="div">
                        {'～'}
                        </Typography>
                        <FormControl className={classes.dateSelect}>
                            <TextField
                                id="outlined-basic"
                                type="date"
                                variant="outlined"
                                className={classes.dataSelect}
                                margin="normal"
                                value={creationEndDate}
                                onChange={(event) => handleCreationDataEndChange(event.target.value)}
                            />
                        </FormControl>
                    </FormGroup>
                    <FormGroup className={classes.selectKubunArea} row>
                        <Typography variant="body1" className={classes.inputKeyword}>
                            キーワード：
                        </Typography>
                        <FormControl className={classes.keyword}>
                            <TextField
                                id="outlined-basic"
                                variant="outlined"
                                className={classes.conditionLeft}
                                margin="normal"
                                value={keyword}
                                onChange={(event) => setKeyword(event.target.value)} />
                        </FormControl>
                        <SearchButton
                            recordId={recordId}
                            creationStartDate={creationStartDate}
                            creationEndDate={creationEndDate}
                            questionnaireId={selectedQuestionnaireId}
                            setData={setData}
                            keyword={keyword}
                            setAllUpdate={setAllUpdate}
                            setIsLoading={setIsLoading}
                        />
                        <ResetButton
                            setRecordId={setRecordId}
                            setCreationStartDate={setCreationStartDate}
                            setCreationEndDate={setCreationEndDate}
                            setData={setData}
                            setKeyword={setKeyword}
                        />
                    </FormGroup>
                </div>
            </Paper>
        </React.Fragment>
    );
});

SettingUserSearch.propTypes = {
    classes: PropTypes.object.isRequired,
    setData: PropTypes.func.isRequired,
    cookies: PropTypes.object.isRequired,
};


export default withStyles(styles)(SettingUserSearch);